import { useCallback } from "react";
import { useToken } from "../../server/auth/use-token";
import { useClaims } from "../generic/hooks/use-claims";
import { huddle } from "../huddle/huddle";

import type { DependencyList } from "react";

export function useDesignHuddleCallback<In, V>(
  projects: string[],
  callback: (params?: In) => Promise<V>,
  deps: DependencyList,
): (params?: In) => Promise<V> {
  const user = useClaims();
  const getToken = useToken();
  return useCallback(
    async (...args) => {
      const token = await getToken();

      const response = await huddle.POST("/", {
        body: { projects },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const { access_token } = response.data!;
      DSHDLib.configure({ access_token, visitor: false });

      return callback(...args);
    },
    // oxlint-disable-next-line react/use-memo -- Dependency list spreads the caller's deps, so it is not an array literal
    [getToken, user, ...deps],
  );
}
